import { ref, listAll, getDownloadURL, uploadBytes } from 'firebase/storage';
import { homePageCollection, storage } from "../connections/FirebaseConnection";
import { doc, getDoc, updateDoc } from "@firebase/firestore";

export const getDescription = async () => {
    const docRef = doc(homePageCollection, "about");
    const docSnap = await getDoc(docRef);
    if(docSnap.exists()){
        return docSnap.data().description;
    }
}

export const getDestaques = async () => {
    let list: string[] = [];

    const destaquesFolder = ref(storage, "Destaques");
    const snap = await listAll(destaquesFolder);

    for(let i in snap.items){
        let photoUrl = await getDownloadURL(snap.items[i]);
        list.push(photoUrl);
    }

    return list;
}